
import axios from 'axios';
import { API_BASE_URL } from './Constants';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const fetchItems = async () => {
  const response = await api.get('/productos');
  return response.data;
};

export const fetchItemsAll = async () => {
  const response = await api.get('/productos-all');
  return response.data;
};